import { render, staticRenderFns } from "./SectionTile.vue?vue&type=template&id=d51467ea&"
import script from "./SectionTile.vue?vue&type=script&lang=js&"
export * from "./SectionTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports